import React, { useCallback, useEffect, useState } from "react";
import "../style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import SideNav from "components/SideNav";
import Footer from "components/Footer";
import {
  addDoc,
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import { v4 } from "uuid";
import { Link, Routes, Route, useNavigate } from "react-router-dom";
import { CircularProgressbar } from "react-circular-progressbar";
import { useDropzone } from "react-dropzone";
import { db, storage } from "../firebase/firebase";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytes,
  uploadBytesResumable,
} from "firebase/storage";
import { getAuth, onAuthStateChanged } from "firebase/auth";

export default function CreatePlan() {
  const [selLevel, setSelLevel] = useState(null);
  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  const [weeks, setWeeks] = useState(0);
  const [type, setType] = useState("");
  const [loadingWeeks, setLoadingWeeks] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [mediaLink, setMediaLink] = useState("");
  const [mediaUrl, setMediaUrl] = useState("");
  const navigate = useNavigate();
  const [uploadedData, setUploadedData] = useState(false);
  const [loadingValue, setLoadingValue] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const [selGroup, setSelGroup] = useState(null);
  const [groups, setGroups] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);

  function handleKeyDown(e) {
    e.target.style.height = "inherit";
    e.target.style.height = `${e.target.scrollHeight}px`;
  }

  const onDrop = useCallback((acceptedFiles) => {
    setImageUpload(acceptedFiles[0]);
    uploadImage(acceptedFiles[0]);
  }, []);

  const loadPermission = async (urlVar) => {
    const q = query(collection(db, "users"), where("__name__", "==", urlVar));

    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      if (doc.data().isAdmin) {
        setIsAdmin(true);
      }

      setGroups(doc.data().permission_groups);
      setSelGroup(doc.data().permission_groups[0]);
    });
  };

  useEffect(() => {
    const getUser = async () => {
      const auth = await getAuth();

      onAuthStateChanged(auth, (user) => {
        if (user) {
          loadPermission(user.uid);
        } else {
          window.location.replace("/");
        }
      });
    };
    getUser();
  }, []);

  const uploadImage = async (data) => {
    var sendData = imageUpload;

    if (imageUpload == null && data == null) return;

    if (sendData == null) {
      sendData = data;
    }

    setIsLoading(true);

    var dataName = sendData.name + "_" + v4();

    const storage = getStorage();
    const storageRef = ref(storage, `exercises/${dataName}`);

    setMediaUrl(dataName);

    const uploadTask = uploadBytesResumable(storageRef, sendData);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setLoadingValue(progress);
        console.log("Upload is " + progress + "% done");
        switch (snapshot.state) {
          case "paused":
            console.log("Upload is paused");
            break;
          case "running":
            console.log("Upload is running");
            break;
        }
      },
      (error) => {
        alert("Fehler bei Hochladen: " + error);
      },
      () => {
        setUploadedData(true);
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setMediaLink(downloadURL);
          console.log("File available at", downloadURL);
        });
      }
    );
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
  });

  const [imageUpload, setImageUpload] = useState(null);

  const selPage = "plans";

  const handleChange = (event) => {
    const result = event.target.value.replace(/\D/g, "");
    setWeeks(result);
  };

  const onName = (event) => {
    const result = event.target.value;
    setName(result);
  };

  const onLevel = (level) => {
    setSelLevel(level);
  };

  const onNext = () => {
    setLoadingWeeks(false);
  };

  const createPlan = async () => {
    if (desc == "" || name == "" || type == "") {
      alert("Bitte geben sie alle Felder an.");
    } else {
      try {
        var dataName = name + "_" + v4();

        const docRef = doc(db, "plans", dataName);

        var groupsSave = [];
        groupsSave.push(selGroup);

        await setDoc(docRef, {
          desc_de: desc,
          duration: weeks,
          level: selLevel,
          name_de: name,
          isActive: isActive,
          type: type,
          media_link: mediaLink,
          media_url: mediaUrl,
          permission_groups: groupsSave,
        }).then(() => {
          setTimeout(() => {
            var refString = "editplan?planid=" + dataName;
            window.location.replace(refString);
            alert("Plan erstellt, füge dem Plan nun Trainingseinheiten hinzu.");
          });
        });
      } catch (err) {
        alert("Error adding document: ");
        alert("" + err);
        console.error("Error adding document: ", err);
      }
    }
  };

  useEffect(() => {}, []);

  const Content = () => (
    <section className="home-section">
      <div className="text">Plan erstellen</div>
      {/* levels */}
      <section className="services-picker" id="plans">
        <div className="container">
          <h2 style={{ marginBottom: "40px" }}>
            Wähle das Traininglevel für deinen Plan
          </h2>
          <div className="grid">
            <a
              onClick={() => {
                onLevel(0);
              }}
              href="#plan-data"
              id="level-1"
              className={"flex-row" + (selLevel == 0 ? " level-selected" : "")}
            >
              <i className="fa-solid fa-check">
                <FontAwesomeIcon
                  icon={icon({ name: "check", style: "solid" })}
                />
              </i>
              <div className="right">
                <h3>Anfänger</h3>
                <p>Einfacher Stufe, 0-6 Monate Erfahrung.</p>
              </div>
            </a>
            <a
              onClick={() => {
                onLevel(1);
              }}
              href="#plan-data"
              className={"flex-row" + (selLevel == 1 ? " level-selected" : "")}
              id="level-2"
            >
              <i className="fa-solid fa-check">
                <FontAwesomeIcon
                  icon={icon({ name: "check", style: "solid" })}
                />
              </i>
              <div className="right">
                <h3>Fortgeschritten</h3>
                <p>Fortgeschrittene Stufe. 6 Monate bis 2 Jahre Erfahrung.</p>
              </div>
            </a>
            <a
              onClick={() => {
                onLevel(2);
              }}
              href="#plan-data"
              className={"flex-row" + (selLevel == 2 ? " level-selected" : "")}
              id="level-3"
            >
              <i className="fa-solid fa-check">
                <FontAwesomeIcon
                  icon={icon({ name: "check", style: "solid" })}
                />
              </i>
              <div className="right">
                <h3>Profi</h3>
                <p>Pofi Level. Über 2 Jahre - x Jahre Erfahrung.</p>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* Plan Data */}
      <section
        className={"plan-data" + (selLevel == null ? " display-none" : "")}
        id="plan-data"
      >
        <div className="container">
          <h2>Gib Informationen über deinen Plan ein</h2>
          <form className="contact-form">
            <p>Name:</p>
            <input
              value={name}
              onChange={(evt) => {
                onName(evt);
              }}
              type="search"
              className="plan-name"
              placeholder="Name"
              key="name"
            />
            <p>Beschreibung:</p>
            <textarea
              onKeyDown={(keydown) => {
                handleKeyDown(keydown);
              }}
              value={desc}
              onChange={(evt) => {
                setDesc(evt.target.value);
              }}
              className="plan-desc"
              placeholder="Beschreibung"
              key="desc"
            ></textarea>
            {/* <p>Dauer in Wochen:</p>
            <input
              type="number"
              key="quantitykey"
              min="1"
              max="52"
              value={weeks}
              onChange={handleChange}
              className="plan-weeks"
            /> */}
            <p>Typ</p>
            <input
              value={type}
              onChange={(evt) => {
                setType(evt.target.value);
              }}
              type="search"
              key="type"
              className="plan-type"
              placeholder="Ausdauer, Kraft..."
            />

            <div style={{ height: 5 }}></div>

            {isAdmin && (
              <a
                style={{ cursor: "pointer", marginTop: 20 }}
                onClick={() => {
                  setIsActive(!isActive);
                }}
              >
                <div className="list-container">
                  <div
                    style={{
                      backgroundColor: "#fff",
                      borderBottom: "1px solid hsl(210, 14%, 83%)",
                      paddingTop: 10,
                      paddingBottom: 10,
                    }}
                    className="list-item"
                  >
                    <p
                      style={{
                        padding: 2,
                        border: "1px solid hsl(210, 14%, 83%)",
                        marginRight: 15,
                        marginLeft: 10,
                        backgroundColor: "#fff",
                      }}
                    >
                      <FontAwesomeIcon
                        style={{ color: isActive ? "#21252b" : "transparent" }}
                        icon={icon({ name: "check", style: "solid" })}
                      />
                    </p>
                    <p style={{ color: "#000", fontSize: 14 }}>
                      {"Öffentlich"}
                    </p>
                  </div>
                </div>
              </a>
            )}

            <p>Gruppe</p>
            <select
              style={{
                padding: "8px",
                width: "100%",
                border: "1px solid #ced4da",
              }}
              id="plan-level"
              name="plan"
              value={selGroup}
              onChange={(evt) => {
                setSelGroup(evt.target.value);
              }}
            >
              {groups?.map((obj) => {
                return <option value={obj}>{obj}</option>;
              })}
            </select>
          </form>

          <>
            <div className="form-button" {...getRootProps()}>
              <p>Bild</p>

              <input {...getInputProps()} />
              {uploadedData ? (
                <>
                  <div
                    className={
                      "dropzone " + (isDragActive ? "active-dropzone" : "")
                    }
                    style={{ padding: 30 }}
                  >
                    <i
                      style={{
                        color: "#fff",
                        backgroundColor: "#7a3260",
                        borderRadius: 999,
                        padding: 10,
                      }}
                      className="fa-solid fa-check"
                    >
                      <FontAwesomeIcon
                        style={{ width: 60, height: 60 }}
                        icon={icon({ name: "check", style: "solid" })}
                      />
                    </i>
                    <span>{imageUpload.name}</span>
                  </div>
                </>
              ) : isLoading ? (
                <div
                  className={
                    "dropzone " + (isDragActive ? "active-dropzone" : "")
                  }
                  style={{ padding: 30 }}
                >
                  <CircularProgressbar value={loadingValue} />
                  <span>Datei wird hochgeladen...</span>
                </div>
              ) : (
                <>
                  <div
                    className={
                      "dropzone " + (isDragActive ? "active-dropzone" : "")
                    }
                  >
                    <span>Drag and Drop</span>
                    <span>oder</span>
                    <label htmlFor="dropzoneFile">Datei auswählen</label>
                    <input
                      onChange={(evt) => {
                        setImageUpload(evt.target.files[0]);
                        uploadImage(evt.target.files[0]);
                      }}
                      type="file"
                      id="dropzoneFile"
                    />
                  </div>
                </>
              )}
            </div>
          </>

          <div className="form-button">
            <div style={{ display: "flex" }}>
              <button
                onClick={() => createPlan()}
                className="btn submit-form"
                type="submit"
              >
                Erstellen
              </button>
              <div style={{ width: 10 }}></div>

              <button
                onClick={() => navigate(-2)}
                className="btn btn-gray submit-form"
                type="submit"
              >
                Abbrechen
              </button>
            </div>
          </div>
        </div>
      </section>
    </section>
  );

  return (
    <>
      <head>
        <link
          href="https://unpkg.com/boxicons@2.0.7/css/boxicons.min.css"
          rel="stylesheet"
        />
      </head>

      {SideNav({
        Content,
        selPage,
      })}
    </>
  );
}
